var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.751 12l1.177-1.183-3.962-3.98h14.816V5.163H3.966l3.962-3.982L6.75 0 1.957 4.818.78 6l1.177 1.182L6.751 12z"}));
}

ArrowLeft.defaultProps = {"width":"18","height":"12","viewBox":"0 0 18 12"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
